import { flushSync } from 'react-dom';

type DocumentWithViewTransition = Document & { startViewTransition?: (update: () => void) => unknown };

/**
 * Runs a navigation inside the browser's View Transition, so elements that share a view-transition-name (the score
 * cards) glide between pages and the rest cross-fades. Falls back to a plain navigation where the API is missing or
 * the user prefers reduced motion.
 */
export const withViewTransition = (go: () => void) => {
  const doc = document as DocumentWithViewTransition;
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (!doc.startViewTransition || reduced) {
    go();
    return;
  }
  doc.startViewTransition(() => flushSync(go));
};
